define('view/controller/booking/result/BookingCancellationErrorView',['require','lib/view/LayoutView'],function (require) {

    var LayoutView = require('lib/view/LayoutView');

    /**
     * Booking cancellation error view
     *
     * @class BookingCancellationErrorView
     */
    return LayoutView.extend({

        template: '#booking_cancellation_error',

        serializeData: function () {
            var result = LayoutView.prototype.serializeData.apply(this);
            result.error = this.getOption('error');

            return result;
        }

    });

});
